enum CupSize {
  FourOz = 4,
  SixOz = 6,
  EightOz = 8,
  TenOz = 10,
  TwelveOz = 12,
  SixteenOz = 16,
  TwentyOz = 20,
}

const CupSizeDisplayNames: Record<CupSize, string> = {
  [CupSize.FourOz]: '4 oz',
  [CupSize.SixOz]: '6 oz',
  [CupSize.EightOz]: '8 oz',
  [CupSize.TenOz]: '10 oz',
  [CupSize.TwelveOz]: '12 oz',
  [CupSize.SixteenOz]: '16 oz',
  [CupSize.TwentyOz]: '20 oz',
};

export const availableCupSize: CupSizeOption[] = [
  { key: CupSize.FourOz, value: CupSizeDisplayNames[CupSize.FourOz] },
  { key: CupSize.SixOz, value: CupSizeDisplayNames[CupSize.SixOz] },
  { key: CupSize.EightOz, value: CupSizeDisplayNames[CupSize.EightOz] },
  { key: CupSize.TenOz, value: CupSizeDisplayNames[CupSize.TenOz] },
  { key: CupSize.TwelveOz, value: CupSizeDisplayNames[CupSize.TwelveOz] },
  { key: CupSize.SixteenOz, value: CupSizeDisplayNames[CupSize.SixteenOz] },
  { key: CupSize.TwentyOz, value: CupSizeDisplayNames[CupSize.TwentyOz] },
];

export type CupSizeOption = {
    key: number;
    value: string;
}; 
